module.exports = __webpack_public_path__ + "img/MicOff.7b895199.png";